import { defineStore } from 'pinia';
import type { Vehicle } from '~/types/generated-types';

interface VehicleContextState {
  _vehicleInformation: Vehicle | undefined;
}

const initialState: () => VehicleContextState = () => {
  return {
    _vehicleInformation: undefined,
  };
};

export const useVehicleContext = defineStore('vehicleContext', {
  state: initialState,
  persist: {
    storage: persistedState.sessionStorage,
  },
  getters: {
    vehicleInformation: (state: VehicleContextState): Vehicle | undefined => state._vehicleInformation,
    isDefined: (state: VehicleContextState): boolean =>
      state._vehicleInformation !== undefined &&
      state._vehicleInformation?.model !== undefined &&
      state._vehicleInformation?.make !== undefined,
    hasTireHotel: (state: VehicleContextState): boolean => {
      return (
        state._vehicleInformation?.tireHotelInformation !== null && state._vehicleInformation?.tireHotelInformation !== undefined // &&
        //  state._vehicleInformation?.tireHotelInformation?.branchId !== '00000000-0000-0000-0000-000000000000'
      );
    },
  },
  actions: {
    changeVehicleInformation(vehicleInformation: Vehicle | undefined): void {
      this._vehicleInformation = vehicleInformation;
    },
  },
});
